
document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded');
    const cards = document.querySelectorAll('[data-component="product-card"]');
    console.log('cards', cards);
    cards.forEach(card => {
        const toggleWrapper = card.querySelector('[data-toggle-info]');
        const toggleButton = card.querySelector('.product-card__toggle');
        const infoBox = card.querySelector('.product-card__info-box');
        const labelClosed = card.querySelector('.product-card__toggle-label-closed');
        const labelOpen = card.querySelector('.product-card__toggle-label-open');
        
        if (toggleWrapper && toggleButton && infoBox && labelClosed && labelOpen) {
            toggleWrapper.addEventListener('click', () => {
                const currentState = infoBox.getAttribute('data-state');
                const newState = currentState === 'collapsed' ? 'expanded' : 'collapsed';
                
                // Update info box state
                infoBox.setAttribute('data-state', newState);
                toggleButton.setAttribute('aria-expanded', newState === 'expanded');
                
                // Toggle label visibility
                if (newState === 'expanded') {
                    labelClosed.style.display = 'none';
                    labelOpen.style.display = 'inline';
                } else {
                    labelClosed.style.display = 'inline';
                    labelOpen.style.display = 'none';
                }
            });
        }
    });
});